const recordListCol = [
    {
        title: '交易流水号',
        key: 'txSn',
        minWidth: 200,
    },
    {
        title: '退款发起时间',
        key: 'startTime',
        minWidth: 150,
    },
    {
        title: '退款完成时间',
        minWidth: 150,
        render: (h, p) => {
            return [p.row.successTime || '-'];
        },
    },
    {
        title: '退款渠道',
        minWidth: 100,
        render: (h, p) => {
            const payTypeMap = {
                0: '快捷',
                1: '微信',
                2: '支付宝',
                3: '返利',
                4: '储蓄卡',
                5: '信用卡',
                6: '授信',
            };
            return [payTypeMap[p.row.payType] || '-'];
        },
    },
    {
        title: '退款金额',
        key: 'totalAmount',
        minWidth: 100,
    },
    {
        title: '受理状态',
        key: 'statusStr',
        minWidth: 100,
    },
    {
        title: '备注',
        minWidth: 200,
        render: (h, p) => {
            return [p.row.remark || '-'];
        },
    },
];

// 退款表头列表
const refundColumns = [
    {
        title: '商品名称',
        key: 'productName',
        align: 'center',
        minWidth: 130,
        fixed: 'left',
        ellipsis: true,
        tooltip: true,
    },
    {
        title: '单价付款',
        align: 'center',
        minWidth: 100,
        render: (h, { row }) => {
            return h('div', row.amount == null ? '-' : row.amount);
        },
    },
    {
        title: '定金付款',
        align: 'center',
        minWidth: 100,
        render: (h, { row }) => {
            return h('div', row.payDeposit == null ? '-' : row.payDeposit);
        },
    },
    { title: '下单数量', key: 'quantity', align: 'center', minWidth: 100 },
    { title: '扫码入库数量', key: 'storageQuantity', align: 'center', minWidth: 120 },
    {
        title: '入库胎号',
        key: 'storageTyreCode',
        align: 'center',
        minWidth: 150,
        render: (h, { row }) => {
            return [row.storageTyreCode || '-'];
        },
    },
    {
        title: '已退数量',
        align: 'center',
        minWidth: 100,
        render: (h, { row }) => {
            return [row.refundQuantity || '-'];
        },
    },
    { title: '可退数量', key: 'canRefundQuantity', align: 'center', minWidth: 100 },
];

// 标记发货-表头
const markDeliverGoodsColumns = [
    {
        title: '商品名称',
        key: 'productName',
        minWidth: 180,
        fixed: 'left',
        render: (h, { row }) => {
            return h('p', { class: { lineTwo: true } }, row.productName);
        },
    },
    {
        title: '单价',
        minWidth: 100,
        render: (h, { row }) => {
            return h('div', row.amount == null ? '-' : row.amount);
        },
    },
    { title: '下单数量', key: 'quantity', minWidth: 80 },
    { title: '已退/已取消数量', key: 'refundOrCancelQuantity', minWidth: 120 },
    { title: '已发货数量', key: 'sendGoodsQuantity', minWidth: 100 },
    {
        title: '待发货数量',
        key: 'canSendGoodQuantity',
        minWidth: 100,
        render: (h, { row }) => {
            return h('div', row.canSendGoodQuantity < 0 ? 0 : row.canSendGoodQuantity);
        },
    },
];

export { recordListCol, refundColumns, markDeliverGoodsColumns };
